import {
  ChangeConfigurationStatus,
  TimelineEventSeverity,
  TimelineType,
  TransactionStopSource,
} from '@core/api/charger-details/charger-details.enums';

import {
  ConfigurationChangeStatusStoreModelEnum,
  TimelineEventSeverityStoreModelEnum,
  TimelineTypeStoreModelEnum,
  TransactionStopSourceStoreModelEnum,
} from './charger-details.enums';

export const mapTimelineEventSeverityApiModelEnumToStoreModelEnum = (
  timelineEventSeverity: TimelineEventSeverity
): TimelineEventSeverityStoreModelEnum => {
  return {
    [TimelineEventSeverity.Normal]: TimelineEventSeverityStoreModelEnum.Normal,
    [TimelineEventSeverity.Warning]: TimelineEventSeverityStoreModelEnum.Warning,
    [TimelineEventSeverity.Alert]: TimelineEventSeverityStoreModelEnum.Alert,
  }[timelineEventSeverity];
};

export const mapTimelineTypeApiModelEnumToStoreModelEnum = (timelineType: TimelineType): TimelineTypeStoreModelEnum => {
  return {
    [TimelineType.AdaptivePowerCapChangeEvent]: TimelineTypeStoreModelEnum.AdaptivePowerCapChangeEvent,
    [TimelineType.AuthorizationFailedEvent]: TimelineTypeStoreModelEnum.AuthorizationFailedEvent,
    [TimelineType.AuthorizationSuccessfulEvent]: TimelineTypeStoreModelEnum.AuthorizationSuccessfulEvent,
    [TimelineType.BootNotificationEvent]: TimelineTypeStoreModelEnum.BootNotificationEvent,
    [TimelineType.ChargingFaultedEvent]: TimelineTypeStoreModelEnum.ChargingFaultedEvent,
    [TimelineType.CsFaultedEvent]: TimelineTypeStoreModelEnum.CsFaultedEvent,
    [TimelineType.EvseFaultedEvent]: TimelineTypeStoreModelEnum.EvseFaultedEvent,
    [TimelineType.CsStateChangeEvent]: TimelineTypeStoreModelEnum.CsStateChangeEvent,
    [TimelineType.CustomCommandEvent]: TimelineTypeStoreModelEnum.CustomCommandEvent,
    [TimelineType.ForceDisconnectEvent]: TimelineTypeStoreModelEnum.ForceDisconnectEvent,
    [TimelineType.HardResetEvent]: TimelineTypeStoreModelEnum.HardResetEvent,
    [TimelineType.SoftResetEvent]: TimelineTypeStoreModelEnum.SoftResetEvent,
    [TimelineType.PowerLimitChangeEvent]: TimelineTypeStoreModelEnum.PowerLimitChangeEvent,
    [TimelineType.PowerLimitChangeRejectedEvent]: TimelineTypeStoreModelEnum.PowerLimitChangeRejectedEvent,
    [TimelineType.PowerOverrideClearedEvent]: TimelineTypeStoreModelEnum.PowerOverrideClearedEvent,
    [TimelineType.ManualPrioritySetEvent]: TimelineTypeStoreModelEnum.ManualPrioritySetEvent,
    [TimelineType.ManualPriorityClearedEvent]: TimelineTypeStoreModelEnum.ManualPriorityClearedEvent,
    [TimelineType.StatusNotificationEvent]: TimelineTypeStoreModelEnum.StatusNotificationEvent,
    [TimelineType.SessionClosedEvent]: TimelineTypeStoreModelEnum.SessionClosedEvent,
    [TimelineType.SessionOpenedEvent]: TimelineTypeStoreModelEnum.SessionOpenedEvent,
    [TimelineType.TransactionBlockedEvent]: TimelineTypeStoreModelEnum.TransactionBlockedEvent,
    [TimelineType.TransactionStartedEvent]: TimelineTypeStoreModelEnum.TransactionStartedEvent,
    [TimelineType.TransactionRemoteStartEvent]: TimelineTypeStoreModelEnum.TransactionRemoteStartEvent,
    [TimelineType.TransactionStoppedEvent]: TimelineTypeStoreModelEnum.TransactionStoppedEvent,
    [TimelineType.TransactionRemoteStopEvent]: TimelineTypeStoreModelEnum.TransactionRemoteStopEvent,
    [TimelineType.TriggerMessageEvent]: TimelineTypeStoreModelEnum.TriggerMessageEvent,
    [TimelineType.UnlockConnectorEvent]: TimelineTypeStoreModelEnum.UnlockConnectorEvent,
    [TimelineType.UnknownVehiclePluggedInEvent]: TimelineTypeStoreModelEnum.UnknownVehiclePluggedInEvent,
    [TimelineType.UnrecognizableOcppMessageEvent]: TimelineTypeStoreModelEnum.UnrecognizableOcppMessageEvent,
    [TimelineType.VehiclePluggedInEvent]: TimelineTypeStoreModelEnum.VehiclePluggedInEvent,
    [TimelineType.VehicleUnpluggedEvent]: TimelineTypeStoreModelEnum.VehicleUnpluggedEvent,
  }[timelineType];
};

export const mapTransactionStopSourceApiModelEnumToStoreModelEnum = (
  transactionStopSource: TransactionStopSource
): TransactionStopSourceStoreModelEnum => {
  return {
    [TransactionStopSource.Charger]: TransactionStopSourceStoreModelEnum.Charger,
    [TransactionStopSource.Ems]: TransactionStopSourceStoreModelEnum.Ems,
    [TransactionStopSource.Be]: TransactionStopSourceStoreModelEnum.Be,
    [TransactionStopSource.Lc]: TransactionStopSourceStoreModelEnum.Lc,
  }[transactionStopSource];
};

export const mapChangeConfigurationStatusApiModelEnumToStoreModelEnum = (
  changeConfigurationStatus: ChangeConfigurationStatus
): ConfigurationChangeStatusStoreModelEnum => {
  return {
    [ChangeConfigurationStatus.Accepted]: ConfigurationChangeStatusStoreModelEnum.Accepted,
    [ChangeConfigurationStatus.Rejected]: ConfigurationChangeStatusStoreModelEnum.Rejected,
    [ChangeConfigurationStatus.RebootRequired]: ConfigurationChangeStatusStoreModelEnum.RebootRequired,
    [ChangeConfigurationStatus.NotSupported]: ConfigurationChangeStatusStoreModelEnum.NotSupported,
    [ChangeConfigurationStatus.Failed]: ConfigurationChangeStatusStoreModelEnum.Failed,
  }[changeConfigurationStatus];
};
